import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { ActivityHistory } from '../../audit.model';
import { CapaService } from '../../capa.service';
import { TableData, TableOptions } from '../../../shared/shared.model';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';

@Component({
  selector: 'iaud-activity-history-expansion',
  templateUrl: './activity-history-expansion.component.html',
  styleUrls: ['./activity-history-expansion.component.scss']
})
export class ActivityHistoryExpansionComponent implements OnInit {

  @Input()
  capaId: number;
  @Input()
  reload?: EventEmitter<boolean>;

  forceReloadEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  historyTableData: TableData<ActivityHistory>;
  historyTableOptions: TableOptions = {
    actionButtons: false,
    columns: [
      {
        title: 'Activity Name',
        fieldName: 'name',
      },
      {
        title: 'Activity Status',
        fieldName: 'status',
      },
      {
        title: 'Due Date',
        fieldName: 'dueDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
      {
        title: 'Submission Date',
        fieldName: 'submissionDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
      {
        title: 'Submitted By',
        fieldName: 'createdBy',
      },
    ],
  };

  constructor(private capaService: CapaService) { }

  ngOnInit(): void {
    if (this.reload) {
      this.reload.subscribe(() => {
        this.forceReloadEvent.emit(true);
      });
    }
    this.reloadHistory()
      .subscribe(table => {
        this.historyTableData = table;
      });
  }
  reloadHistory(page: number = 0, pageSize: number = 10): Observable<TableData<ActivityHistory>> {
    return this.capaService.getActivities(this.capaId, page, pageSize);
  }
}
